<template>
  <div>
    <!-- <div class="card">
      <div class="card-body"> -->
        <div class="card-header card-header-flex">
          <div class="d-flex flex-column justify-content-center mr-auto">
          <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
            <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
              v-clipboard:success="onCopy" v-clipboard:error="onError"><i class="fa fa-copy mr-1" />Copy!
            </b-dropdown-item>
            <b-dropdown-item @click="checkDataExcel(json_data)">
              <download-excel :data="json_data" :fields="json_fields" :name="fileName">
                <i class="fa fa-file-excel-o mr-1" />Export Excel Select
              </download-excel>
            </b-dropdown-item>
            <b-dropdown-item>
              <download-excel :data="dataExport" :fields="json_fields" :name="fileName">
                <i class="fa fa-file-excel-o mr-1" />Export Excel All
              </download-excel>
            </b-dropdown-item>
          </b-dropdown>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <a-checkbox @change="getAutoRefresh(refresh)">
                รีเฟรชอัตโนมัติ {{(this.refresh) ? myVal : ''}}
            </a-checkbox>
          </div>
          <div class="d-flex flex-column justify-content-center" style="margin-right: 5px;">
            <a class="btn btn-primary" href="javascript: void(0);" @click="createTranfer()"><i
              class="fe fe-plus mr-1" /> สร้างรายการ</a>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
              class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
          </div>
        </div>
        <a-table :columns="columns" :dataSource="dataTable" rowKey='id' :row-selection="rowSelection" :scroll="{ x: 1500 }"
        :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="custom-filter-dropdown"
          >
            <a-input
              v-ant-ref="c => searchInput = c"
              :placeholder="`Search ${column.dataIndex}`"
              :value="selectedKeys[0]"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
              style="width: 188px; margin-bottom: 8px; display: block;"
            />
            <a-button
              type="primary"
              @click="() => handleSearch(selectedKeys, confirm)"
              size="small"
              style="width: 90px; margin-right: 8px"
            >Search</a-button>
            <a-button
              @click="() => handleReset(clearFilters)"
              size="small"
              style="width: 90px"
            >Reset</a-button>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template slot="progress" slot-scope="bar">
            <div class="progress">
              <div
                :class="['progress-bar', bar.color]"
                :style="{width: bar.value + '%'}"
                role="progressbar"
              ></div>
            </div>
          </template>
          <h6 slot="WithdrawStatus" slot-scope="text , record">
            <b-badge pill :variant="getStatus('tranferAtm',text).color" href="#" @click="useAction(record.withdrawATMCode, record.withdrawATMStatus)">{{getStatus('tranferAtm',text).name}}</b-badge>
          </h6>
          <!-- <h6 slot="TranferStatus" slot-scope="text , record">
            <b-badge pill :variant="getStatus('tranfer',text).color" href="#" @click="useAction(record.id, text, record.tranferPaymentId, 'tranfer')">{{getStatus('tranfer',text).name}}</b-badge>
          </h6> -->
        </a-table>
      <!-- </div>
    </div> -->
    <a-modal v-model="modelShowDetail" title="ข้อมูลรายการที่จับคู่" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false"  @ok="useModal">
      <div class="mb-5">
        <h5 class="mb-4">
          <strong>รายละเอียดรายการที่จับคู่กับ # {{(!this.datatransection.tranferId)?"ไม่พบข้อมูล":this.datatransection.tranferId }}</strong>
        </h5>
        <a-skeleton :active="loadingModal" :loading="loadingActive" />
        <dl class="row" v-if="loadingModal !== true">
          <dt class="col-sm-4">รหัสโยกเงิน :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.paymentId)?"ไม่พบข้อมูล":this.datatransection.paymentId }}</dd>

          <dt class="col-sm-4">บัญชีโยกเงิน :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.bankServiceSystem)?"ไม่พบข้อมูล":this.datatransection.bankServiceSystem }}</dd>

          <dt class="col-sm-4">บัญชีรับเงิน :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.bankTranferSystem)?"ไม่พบข้อมูล":this.datatransection.bankTranferSystem }}</dd>

          <dt class="col-sm-4">เวลาทำรายการ :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.bankPaymentCreatedAt)?"ไม่พบข้อมูล":this.datatransection.bankPaymentCreatedAt }}</dd>

          <dt class="col-sm-4 text-truncate">จำนวนเงิน :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.amount)?"ไม่พบข้อมูล":this.datatransection.amount }}</dd>

          <dt class="col-sm-4 text-truncate">รายละเอียด :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.detail)?"ไม่พบข้อมูล":this.datatransection.detail }}</dd>

          <dt class="col-sm-4 text-truncate">รายละเอียดโยกเงิน :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.detailBankNumber)?"ไม่พบข้อมูล":this.datatransection.detailBankNumber }}</dd>

          <dt class="col-sm-4 text-truncate">หมายเหตุ :</dt>
          <dd class="col-sm-8">{{(!this.datatransection.bankPaymentRemark)?"ไม่พบข้อมูล":this.datatransection.bankPaymentRemark }}</dd>

          <dt class="col-sm-4">สถานะ :</dt>
          <dd class="col-sm-8"><b-badge pill :variant="(!this.datatransection.color)?'info':this.datatransection.color">{{(!this.datatransection.status)?"ไม่พบข้อมูล":this.datatransection.status }}</b-badge></dd>
        </dl>
      </div>
    </a-modal>
    <a-modal title="ตรวจสอบบัญชีธนาคาร" v-model="visibleCheckBank" ok-text="ยืนยัน" cancel-text="ยกเลิก"
        @ok="handleSubmit" @cancel="modalCheckBankClose">
        <a-form-model :model="forms" layout="vertical">
          <div class="align-items-center">
            <a-form-item label="ธนาคาร">
              <a-select v-model="forms.bankId" placeholder="กรุณาเลือกข้อมูล">
                <a-select-option v-for="(item , index) in banks" :key="index" :value="item.id">
                  {{ item.bankName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="เลขบัญชี">
              <a-input v-model="forms.accountNumber" />
            </a-form-item>
          </div>
        </a-form-model>
    </a-modal>
    <a-modal v-model="modelCreateTranfer" title="สร้างรายการโยกเงิน" ok-text="ยืนยัน" cancel-text="ยกเลิก" showCancelButton="false" @cancel="cancelModalConfime"  @ok="useModalConfime">
      <a-form-model ref="ruleForm" :model="formtranfer" layout="vertical" :rules="rules">
        <div class="row">
                  <div class="col-md-12">
                      <a-form-model-item label="ธนาคารลูกค้า" >
                          <a-input
                              v-model="formtranfer.bank"
                              size="large"
                              style="width: 100%"
                              disabled
                          />
                      </a-form-model-item>
                  </div>
                  <div class="col-md-12">
                      <a-form-model-item label="เลขบัญชี" >
                          <a-input
                              v-model="formtranfer.accountNumber"
                              size="large"
                              style="width: 100%"
                              disabled
                          />
                      </a-form-model-item>
                  </div>
                  <div class="col-md-12">
                      <a-form-model-item label="ชื่อบัญชี" >
                          <a-input
                              v-model="formtranfer.accountNameToBank"
                              size="large"
                              style="width: 100%"
                              disabled
                          />
                      </a-form-model-item>
                  </div>
                  <div class="col-md-12">
                      <a-form-model-item label="ชื่อบัญชี(EN)" >
                          <a-input
                              v-model="formtranfer.accountNameToBankEng"
                              disabled
                              size="large"
                              style="width: 100%"
                          />
                      </a-form-model-item>
                  </div>
                  <div class="col-md-12">
                      <a-form-model-item label="คู่ค้า" prop="operator">
                          <a-select
                              v-model="formtranfer.operator"
                              show-search
                              placeholder="กรุณาเลือกข้อมูล"
                              style="width: 100%"
                              @select="setOperatorMain"
                          >
                              <a-select-option value="">
                                  กรุณาเลือกข้อมูล
                              </a-select-option>
                              <a-select-option v-for="(item , index) in OperatorList" :key="index" :value="item.name">
                                  {{ item.name }}
                              </a-select-option>
                          </a-select>
                      </a-form-model-item>
                  </div>
                  <div class="col-md-12">
                      <a-form-model-item label="บัญชีระบบ" prop="bankservice">
                          <a-select
                              v-model="formtranfer.bankServiceId"
                              show-search
                              placeholder="กรุณาเลือกข้อมูล"
                              style="width: 100%"
                              :disabled="(bankService)?false:true"
                              @select="setBankService"
                          >
                              <a-select-option value="">
                                  กรุณาเลือกข้อมูล
                              </a-select-option>
                              <a-select-option
                                  v-for="(item , index) in bankService" :key="index" :value="item.bankServiceId">
                                  {{ item.bankServiceSystem }}
                              </a-select-option>
                          </a-select>
                      </a-form-model-item>
                  </div>
                  <div class="col-md-12">
                      <a-form-model-item label="จำนวนเงิน" prop="amount">
                          <a-input-number
                              v-model="formtranfer.amount"
                              size="large"
                              style="width: 100%"
                          />
                      </a-form-model-item>
                  </div>
                  <div class="col-md-12">
                      <a-form-model-item label="หมายเหตุ" prop="remark">
                          <a-input
                              v-model="formtranfer.remark"
                              size="large"
                              style="width: 100%"
                          />
                      </a-form-model-item>
                  </div>
              </div>
       </a-form-model>
    </a-modal>
  </div>
</template>
<script>
// import { Modal, notification } from 'ant-design-vue'
// import data from './data.json'
import { mapGetters } from 'vuex'
import moment from 'moment'
import momentTz from 'moment-timezone'
import apiClient from '@/services/api'
import { getName } from '@/utils/status'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
function CopyMe(TextToCopy) {
  var TempText = document.createElement('textarea')
  TempText.value = TextToCopy
  document.body.appendChild(TempText)
  TempText.select()
  document.execCommand('copy')
  document.body.removeChild(TempText)
}
const columns = [
  {
    title: 'withdrawATMCode',
    dataIndex: 'withdrawATMCode',
    width: 200,
    // sorter: (a, b) => a.id - b.id,
    // scopedSlots: {
    //   filterDropdown: 'filterDropdown',
    //   filterIcon: 'filterIcon',
    //   customRender: 'id',
    // },
    // onFilter: (value, record) => record.id.toLowerCase().includes(value.toLowerCase()),
  },
  {
    title: 'คู่ค้า',
    dataIndex: 'operatorName',
    width: 100,
    // sorter: (a, b) => a.operatorMainName.length - b.operatorMainName.length,
    // scopedSlots: {
    //   filterDropdown: 'filterDropdown',
    //   filterIcon: 'filterIcon',
    //   customRender: 'operatorMainName',
    // },
    filters: [],
    onFilter: (value, record) => record.operatorMainName.toLowerCase().includes(value.toLowerCase()),
  },
  {
    title: 'บัญชีโยกเงิน',
    dataIndex: 'bankServiceSystem',
    filters: [
      { text: 'scb', value: 5 },
      { text: 'kbank', value: 6 },
      { text: 'ktb', value: 4 },
    ],
    onFilter: (value, record) => record.bankSvId.toString().includes(value.toString()),
  },
  {
    title: 'บัญชีรับเงิน',
    dataIndex: 'bankServiceUser',
    filters: [
      { text: 'scb', value: 5 },
      { text: 'kbank', value: 6 },
      { text: 'ktb', value: 4 },
    ],
    onFilter: (value, record) => record.bankTfId.toString().includes(value.toString()),
  },
  {
    title: 'จำนวนเงิน',
    dataIndex: 'amount',
    customRender: (text, row, index) => {
      if (text !== '-') {
        const amountOutComes = parseFloat(text)
        return amountOutComes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return text
    },
  },
  {
    title: 'withdrawStatus',
    dataIndex: 'withdrawATMStatus',
    scopedSlots: { customRender: 'WithdrawStatus' },
  },
  // {
  //   title: 'tranferStatus',
  //   dataIndex: 'tranferStatus',
  //   scopedSlots: { customRender: 'TranferStatus' },
  // },
  {
    title: 'วันที่สร้าง',
    key: 'createdAt',
    dataIndex: 'createdAt',
    width: 150,
    customRender: (text, row, index) => {
      return momentTz(text).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
    },
    // fixed: 'right',

  },
  {
    title: 'วันที่อัปเดท',
    key: 'updatedAt',
    dataIndex: 'updatedAt',
    width: 150,
    customRender: (text, row, index) => {
      return momentTz(text).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss')
    },
    // fixed: 'right',
  },
]
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    data: {
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8',
          },
        ],
      ],
    },
  },
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getSelectOperator: 'getSelectOperator',
      getSelectBankService: 'getSelectBankService',
      getSelectBankTranfer: 'getSelectBankTranfer',
      //   getSelectStatus: 'getSelectStatus',
      getKeyword: 'getKeyword',
      getKeywordTime: 'getKeywordTime',
      getSearchUpdate: 'getSearchUpdate',
    }),
    myVal() {
      if (this.ctr === 0) {
        this.reCountdown()
      }
      return this.ctr
    },
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,

        selections: [
          {
            key: 'all-data',
            text: 'เลือกทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = this.dataTable.map((result) => {
                return result.id
              })
            },
          },
          {
            key: 'del-data',
            text: 'ลบทั้งหมด',
            onSelect: () => {
              this.selectedRowKeys = []
            },
          },
        ],
        onSelection: this.onSelection,
      }
    },
  },
  watch: {
    getStartDate: function(val) {
      if (val) this.loaddata()
    },
    getEndDate: function(val) {
      if (val && !this.checkFistPage) {
        this.loaddata()
      }

      if (this.checkFistPage) this.checkFistPage = false
    },
    getSelectOperator: function(val) {
      if (val) this.loaddata()
    },
    getSelectBankService: function(val) {
      if (val) this.loaddata()
    },
    getSelectBankTranfer: function(val) {
      if (val) this.loaddata()
    },
    // getSelectStatus: function(val) {
    //   if (val) this.loaddata()
    // },
    getKeyword: function(val) {
      if (val) this.loaddata(val)
    },
    getKeywordTime: function(val) {
      if (val) {
        this.loaddata()
      }
    },
    getSearchUpdate: function(val) {
      if (val) {
        this.loaddata()
      }
    },
    selectedRowKeys: function(val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
  },
  data: function () {
    return {
      checkFistPage: true,
      loadingActive: true,
      loadingModal: false,
      json_data: [],
      json_fields: {
        ID: 'id',
        คู่ค้า: 'operatorMainName',
        บัญชีโยกเงิน: 'bankServiceSystem',
        บัญชีรับเงิน: 'bankTranferSystem',
        จำนวนเงิน: 'amount',
        withdrawStatus: 'withdrawStatus',
        tranferStatus: 'tranferStatus',
        วันที่สร้าง: 'createdAt',
      },
      fileName: 'รายการธุรกรรมโยกเงิน' + momentTz().tz('Asia/Bangkok').format('DD-MM-YYYY'),
      modelShowDetail: false,
      modelCreateTranfer: false,
      visibleCheckBank: false,
      dataExport: [],
      visible: false,
      searchText: '',
      searchInput: null,
      confirmLoading: false,
      selectedRowKeys: [],
      dataTable: [],
      operator: [],
      columns,
      formLayout: 'horizontal',
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      datatransection: {
        tranferId: null,
        paymentId: null,
        amount: null,
        detail: null,
        detailBankNumber: null,
        bankPaymentRemark: null,
        bankServiceSystem: null,
        bankTranferSystem: null,
        bankPaymentCreatedAt: null,
        status: null,
        color: null,
      },
      OperatorList: [],
      bankService: [],
      bankTranfer: [],
      form: {
        bankServiceId: '',
        bankTranferId: '',
        amount: '',
        bankShort: '',
        operatorMainId: '',
      },
      formtranfer: {
        operator: '',
        operatorCode: '',
        title: '',
        bankId: '',
        bank: null,
        accountNameToBank: null,
        accountNameToBankEng: null,
        accountNumber: null,
        accountName: null,
        amount: '',
        bankServiceId: '',
        remark: null,
      },
      rules: {
        bankServiceId: [{ required: true, message: 'กรุณาเลือกข้อมูล', trigger: 'change' }],
        bankTranferId: [{ required: true, message: 'กรุณาเลือกข้อมูล', trigger: 'change' }],
        amount: [
          { required: true, message: 'กรุณากรอก จำนวนเงิน', trigger: 'blur' },
        //   { min: 3, max: 5, message: 'ความกรอกเลข IP  3 to 5', trigger: 'blur' },
        ],
        operatorMainId: [{ required: true, message: 'กรุณาเลือกข้อมูล', trigger: 'change' }],
      },
      refresh: false,
      countdown: false,
      counters: '',
      counters2: '',
      ctr: 5,
      forms: {
        bankId: null,
        accountNumber: null,
      },
      banks: [],
    }
  },
  methods: {
    checkDataExcel (data) {
      if (data.length === 0) {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการ Export' })
        return false
      }
    },
    dataToExcel (data) {
      if (data.length > 0) {
        const dataresult = []
        data.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.id === result) {
              return true
            }
          })
          const resultData = {
            // id: item.id,
            operatorMainName: item.operatorMainName,
            bankServiceSystem: item.bankServiceSystem,
            bankTranferSystem: item.bankTranferSystem,
            amount: item.amount,
            withdrawStatus: this.getStatus('tranferAtm', item.withdrawStatus).name,
            // tranferStatus: this.getStatus('tranfer', item.tranferStatus).name,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          }
          dataresult.push(resultData)
        })
        this.json_data = dataresult
      }
    },
    onCopy: function (e) {
      const dataJson = JSON.parse(e.text)
      let row = ''
      if (dataJson.length > 0) {
        dataJson.map(result => {
          // eslint-disable-next-line no-const-assign
          const item = this.dataTable.find((dataResult) => {
            if (dataResult.id === result) {
              return true
            }
          })
          const resultData = {
            // id: item.id,
            operatorMainName: item.operatorMainName,
            bankServiceSystem: item.bankServiceSystem,
            bankTranferSystem: item.bankTranferSystem,
            amount: item.amount,
            withdrawStatus: this.getStatus('tranferAtm', item.withdrawStatus).name,
            // tranferStatus: this.getStatus('tranfer', item.tranferStatus).name,
            createdAt: moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss'),
          }
          const convertObj = Object.values(resultData)
          const col = convertObj.join(' \t ')
          row += `${col} \n`
        })
        // this.clipboard(row)
        CopyMe(row)
        Toast.fire({ icon: 'success', title: 'success copy' })
      } else {
        Toast.fire({ icon: 'error', title: 'กรุณาเลือกข้อมูลที่ต้องการคัดลอก' })
      }
    },
    onError: function (e) {
      Toast.fire({ icon: 'error', title: 'Failed to copy texts' })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    clearForm() {
      this.datatransection = {
        tranferId: null,
        paymentId: null,
        amount: null,
        detail: null,
        detailBankNumber: null,
        bankPaymentRemark: null,
        bankServiceSystem: null,
        bankTranferSystem: null,
        bankPaymentCreatedAt: null,
        status: null,
        color: null,
      }
    },
    useModal(e) {
      this.modelShowDetail = !this.modelShowDetail
    },
    useAction(withdrawATMCode, status) {
      if (status === '001') this.confirmTranfer(withdrawATMCode)
      if (status === '005') this.restatusTranfer(withdrawATMCode)
      if (status === '000') this.showDetailTranfer(withdrawATMCode, status)
      // if (status === '007') this.mangeTranfer(tranferId, statusId, type)
    },
    async showDetailTranfer(withdrawATMCode, status) {
      const dataTranfer = {
        withdrawATMCode: withdrawATMCode,
        status: status,
      }
      this.clearForm()
      this.useModal()
      this.loadingModal = !this.loadingModal
      this.loadingActive = true
      await apiClient.post('/withdrawATM/getTranferDetail', dataTranfer).then(response => {
        const res = response.data
        if (res.code === '000') {
          const getData = res.responseData.data[0]
          // this.useModal()
          const getnameStatus = getName('tranferAtm', getData.withdrawATMStatus)
          const bankPaymentCreatedAt = moment(getData.bankPaymentCreatedAt).format('DD/MM/YYYY HH:mm:ss')
          this.datatransection = {
            tranferId: getData.withdrawATMCode,
            paymentId: getData.bankPaymentId,
            amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
            detail: getData.remark,
            detailBankNumber: getData.detailBankNumber,
            bankPaymentRemark: getData.bankPaymentRemark,
            bankServiceSystem: getData.bankServiceSystem,
            bankTranferSystem: getData.bankServiceUser,
            bankPaymentCreatedAt: bankPaymentCreatedAt,
            status: getnameStatus[0].name,
            color: getnameStatus[0].color,
          }
        }
        this.loadingModal = !this.loadingModal
        this.loadingActive = false
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    async confirmTranfer(withdrawATMCode) {
      const body = {
        withdrawATMCode,
      }
      Swal.fire({
        title: 'ต้องอนุมัติรายการโยกเงินหรือไม่?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'อนุมัติรายการ',
        denyButtonText: 'ยกเลิกรายการ',
        cancelButtonText: 'ปิด',
        customClass: {
          actions: 'my-actions',
          confirmButton: 'order-1 right-gap',
          denyButton: 'order-2',
          cancelButton: 'order-3',
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          await apiClient.post('/withdrawATM/confirmWithdrawATM', body).then(response => {
            const res = response.data
            const iconError = (res.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: res.message })
            this.loaddata()
          }).catch(error => {
            Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
            )
          })
        } else if (result.isDenied) {
          await apiClient.post('/withdrawATM/cancelWithdrawATM', body).then(response => {
            const res = response.data
            const iconError = (res.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: res.message })
            this.loaddata()
          }).catch(error => {
            Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
            )
          })
        }
      })
    },
    async restatusTranfer(withdrawATMCode) {
      const body = {
        withdrawATMCode,
      }
      Swal.fire({
        title: 'ต้องรีเซตรายการโยกเงินหรือไม่?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'รีเซตรายการ',
        denyButtonText: 'ยกเลิกรายการ',
        cancelButtonText: 'ปิด',
        customClass: {
          actions: 'my-actions',
          confirmButton: 'order-1 right-gap',
          denyButton: 'order-2',
          cancelButton: 'order-3',
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          await apiClient.post('/withdrawATM/restatusWithdrawATM', body).then(response => {
            const res = response.data
            const iconError = (res.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: res.message })
            this.loaddata()
          }).catch(error => {
            Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
            )
          })
        } else if (result.isDenied) {
          await apiClient.post('/withdrawATM/cancelWithdrawATM', body).then(response => {
            const res = response.data
            const iconError = (res.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: res.message })
            this.loaddata()
          }).catch(error => {
            Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
            )
          })
        }
      })
    },
    async showDetail(tranferId, statusId, type) {
      const dataTranfer = {
        tranferId: tranferId,
        statusId: statusId,
        type: type,
      }
      this.clearForm()
      this.useModal()
      this.loadingModal = !this.loadingModal
      this.loadingActive = true
      await apiClient.post('/tranfer/getTranferDetail', dataTranfer).then(response => {
        const res = response.data
        if (res.code === '000') {
          const getData = res.responseData.data[0]
          this.useModal()
          const getnameStatus = getName('tranfer', getData.bankPaymentStatus)
          const bankPaymentCreatedAt = moment(getData.bankPaymentCreatedAt).format('DD/MM/YYYY HH:mm:ss')
          this.datatransection = {
            tranferId: getData.id,
            paymentId: getData.bankPaymentId,
            amount: getData.amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
            detail: getData.detail,
            bankServiceSystem: getData.bankServiceSystem,
            bankTranferSystem: getData.bankTranferSystem,
            bankPaymentCreatedAt: bankPaymentCreatedAt,
            status: getnameStatus[0].name,
            color: getnameStatus[0].color,
          }
        }
        this.loadingModal = !this.loadingModal
        this.loadingActive = false
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    mangeTranfer(tranferId, statusId, type) {
      const dataTranfer = {
        tranferId: tranferId,
        statusId: statusId,
        type: type,
      }
      Swal.fire({
        title: 'ต้องอนุมัติรายการโยกเงินหรือไม่?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'อนุมัติรายการ',
        denyButtonText: 'ยกเลิกรายการ',
        cancelButtonText: 'ปิด',
        customClass: {
          actions: 'my-actions',
          confirmButton: 'order-1 right-gap',
          denyButton: 'order-2',
          cancelButton: 'order-3',
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          await apiClient.post('/tranfer/confirmTranfer', dataTranfer).then(response => {
            const res = response.data
            const iconError = (res.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: res.message })
            this.loaddata()
          }).catch(error => {
            Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
            )
          })
        } else if (result.isDenied) {
          await apiClient.post('/tranfer/cancelTranfer', dataTranfer).then(response => {
            const res = response.data
            const iconError = (res.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: res.message })
            this.loaddata()
          }).catch(error => {
            Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
            )
          })
        }
      })
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    exportAll (obj) {
      this.dataExport = []
      let resultData = {}
      obj.map(element => {
        resultData = {
          // id: element.id,
          operatorMainName: element.operatorMainName,
          bankServiceSystem: element.bankServiceSystem,
          bankTranferSystem: element.bankTranferSystem,
          amount: element.amount,
          withdrawStatus: this.getStatus('tranfer', element.withdrawStatus).name,
          // tranferStatus: this.getStatus('tranfer', element.tranferStatus).name,
          createdAt: moment(element.createdAt).format('DD/MM/YYYY HH:mm:ss'),
        }
        this.dataExport.push(resultData)
      })
    },
    loaddata() {
      const dataTranfer = {
        bankTranferId: this.getSelectBankTranfer,
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        operatorCode: this.getSelectOperator,
        bankServiceId: this.getSelectBankService,
        status: this.getSelectStatus,
        keyword: this.getKeyword,
        statusKey: this.statusKey,
        keywordTime: this.getKeywordTime,
        searchUpdate: this.getSearchUpdate,
      }
      // apiClient.post('tranfer/2', dataTranfer).then(res => {
      apiClient.post('withdrawATM/getData', dataTranfer).then(res => {
        if (res.data.code === '000') {
          this.dataTable = res.data.responseData.data
          this.exportAll(res.data.responseData.data)
          if (this.dataTable.length > 0) {
            const listOperater = this.dataTable.map(function(item, pos) {
              return { text: item.operatorMainName, value: item.operatorMainName }
            })
            this.columns[1].filters = [
              ...new Map(listOperater.map((item) => [item.text, item])).values(),
            ]
          }
        }
      })
    },
    handleOk(e) {
      this.confirmLoading = true
      this.onSubmit()
    },
    handleCancel(e) {
      this.visible = false
    },

    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    modalCheckBankClose() {
      this.visibleCheckBank = !this.visibleCheckBank
    },
    clearForms() {
      this.form = {
        bankServiceId: '',
        bankTranferId: '',
        amount: '',
        bankShort: '',
        operatorMainId: '',
      }
    },
    cancelModalConfime() {
      this.clearForms()
      this.OperatorList = []
      this.bankService = []
      this.bankTranfer = []
      // this.modelCreateTranfer = false
    },
    clearFormsTranfer() {
      this.forms = {
        bankId: null,
        accountNumber: null,
      }
    },
    async createTranfer() {
      this.clearFormsTranfer()
      this.visibleCheckBank = true
      await apiClient.get('/system/getBank').then(response => {
        const res = response.data
        if (res.code === '000') {
          this.banks = res.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    async getDataOprator() {
      await apiClient.get('/system/getOperator').then(res => {
        if (res.data.code === '000') {
          const setData = res.data.responseData
          this.OperatorList = setData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
                    `เกิดข้อผิดพลาด: ${error}`,
        )
        // this.visible = !this.visible
      })
    },
    clearFormsData() {
      this.formtranfer = {
        operator: '',
        operatorCode: '',
        title: '',
        bankId: '',
        bank: null,
        accountNameToBank: null,
        accountNameToBankEng: null,
        accountNumber: null,
        accountName: null,
        amount: '',
        bankServiceId: '',
        remark: null,
      }
    },
    async handleSubmit() {
      this.bankId = this.forms.bankId
      this.clearFormsData()
      await apiClient.post('/users/checkBank', this.forms).then(response => {
        const res = response.data
        const iconError = (res.code === '000') ? 'success' : 'error'
        Toast.fire({ icon: iconError, title: res.message })
        if (res.code === '000') {
          const dataUserBank = res.responseData.data
          this.visibleCheckBank = !this.visibleCheckBank
          this.formtranfer = {
            title: 'รายการโยกเงินไปบัญชีกดตู้',
            accountNameToBank: dataUserBank.accountToDisplayName,
            accountNameToBankEng: dataUserBank.accountToName,
            bankId: this.bankId,
            bank: dataUserBank.bankName,
            accountNumber: dataUserBank.accountNumber,
            accountName: dataUserBank.accountToDisplayName,
          }
          this.getDataOprator()
          this.modelCreateTranfer = true
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    setOperatorMain() {
      // console.log(this.formtranfer)
      const operatorMainId = this.OperatorList.find(element => {
        if (element.name === this.formtranfer.operator) {
          return element.id
        }
      })
      this.formtranfer.operatorCode = operatorMainId.operatorCode
      apiClient.get(`/tranfer/getbankService/${operatorMainId.id}`).then(res => {
        if (res.data.code === '000') {
          this.bankService = []
          this.bankService = res.data.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    setBankService() {
      // const item = this.bankService.find((dataResult) => {
      //   if (dataResult.bankServiceId === this.form.bankServiceId) {
      //     return dataResult
      //   }
      // })
      // this.form.bankShort = item.bankshort
      // const body = {
      //   bankShort: this.form.bankShort,
      //   operatorMainId: this.form.operatorMainId,
      // }
      // apiClient.post('/tranfer/getbanktranfer', body).then(res => {
      //   if (res.data.code === '000') {
      //     this.bankTranfer = []
      //     this.bankTranfer = res.data.responseData.data
      //   }
      // }).catch(error => {
      //   Swal.showValidationMessage(
      //     `เกิดข้อผิดพลาด: ${error}`,
      //   )
      // })
    },
    useModalConfime() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const title = 'แน่ใจหรือไม่ที่ต้องการสร้างรายการโยกเงิน'
          Swal.fire({
            icon: 'info',
            title: title,
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
              if (value) {
                // return apiClient.post('tranfer/createTranfer', this.form).then(response => {
                return apiClient.post('withdrawATM/insertData', this.formtranfer).then(response => {
                  if (response.status !== 200) {
                    throw new Error(response.message)
                  }
                  return response.data
                }).catch(error => {
                  Swal.showValidationMessage(
                      `เกิดข้อผิดพลาด: ${error.message}`,
                  )
                })
              }
            },
            allowOutsideClick: () => !Swal.isLoading(),
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              const iconError = (result.value.code === '000') ? 'success' : 'error'
              Toast.fire({ icon: iconError, title: result.value.message })
              this.modelCreateTranfer = false
              this.loaddata()
            }
          })
        }
      })
    },
    getAutoRefresh(refresh) {
      if (!refresh) {
        this.refresh = true
        this.ReloadData(true)
      } else {
        this.refresh = false
        this.ReloadData(false)
      }
    },
    ReloadData (value) {
      if (value) {
        this.countdown = true
        this.counters = setInterval(function () {
          this.loaddata()
        }.bind(this), 5000)
        this.counters2 = setInterval(function () {
          this.ctr = this.ctr - 1
        }.bind(this), 1000)
      } else {
        clearInterval(this.counters)
        clearInterval(this.counters2)
        this.ctr = 5
      }
    },
    reCountdown () {
      this.ctr = 5
    },
    refreshData() {
      this.loading(true)
      this.loaddata()
      this.loading(false)
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
  },
  created() {
    this.loaddata()
  },
}
</script>
<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.my-actions { margin: 0 2em; }
.order-1 { order: 1; }
.order-2 { order: 2; }
.order-3 { order: 3; }

.right-gap {
  margin-right: auto;
}
</style>
